class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus()
      }
    });
  }
  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
    const parentWrap = parentDisplay.querySelector('.parent-wrap');
    this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Handle category filter clicks
  const categoryCheckboxes = document.querySelectorAll('.category-filter-list input[type="checkbox"]');

  categoryCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function(e) {
      const url = this.getAttribute('data-category-url');
      if (url) {
        window.location.href = url;
      }
    });
  });
});
customElements.define('show-more-button', ShowMoreButton);